import { JstDate } from '../../core/time/business-time';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { MarketingService } from '../../core/services/marketing.service';
import { AuthStateService } from '../../core/services/auth-state.service';
import { environment } from '../../../environments/environment';
import Chart from 'chart.js';

function buildYearMonthOptions() {
  const opts = [];
  const now = new JstDate();
  let year = now.getFullYear();
  let month = now.getMonth() + 1;
  for (let i = 0; i < 12; i++) {
    year = month === 1 ? year - 1 : year;
    month = month === 1 ? 12 : month - 1;
    if (year > 2020 || (year === 2020 && month > 10)) {
      opts.push({ id: `${year}-${String(month).padStart(2, '0')}`, name: `${year}年${month}月` });
    }
  }
  return opts;
}

const GRAPH_OPTIONS = [
  { id: 0, name: '入会者数' },
  { id: 1, name: '退会者数' },
  { id: 2, name: '純増会員数' },
  { id: 3, name: '来館入会率' },
  { id: 4, name: '来館者分析' },
  { id: 5, name: '有料PT実施本数' },
];

const GRAPH_NUMBER_OPTIONS = Array.from({ length: 10 }, (_, i) => ({ id: i + 1, name: String(i + 1) }));

interface GraphPanel {
  yearMonth: string;
  graphType: number;
  graphNumber: number;
  showGraphArea: boolean;
  chartInstance: any;
  requestId?: number;
}

@Component({
    selector: 'app-marketing-all',
    imports: [FormsModule],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-list"></i> 一覧</span>
    </div>
    <div class="card-body">
      <form novalidate name="myForm">
      <div class="form-group row">
        <div class="col-md-12">
          <!-- 旧版 marketing-all.html:13: user_permission <= 10 のみ表示、modal open時にupdateExportData() -->
          @if (userPermission <= 10) {
            <button class="btn btn-success text-white" type="button" (click)="openDownloadModal()">
              <i class="fa s-icon-dawnload"></i>&nbsp;ダウンロード
            </button>
          }
          <button class="btn btn-primary text-white ml-1" type="button" (click)="showGraph()" [disabled]="loadingPanels > 0 || panels.length >= graphOptions.length">
            <i class="fa s-icon-plus"></i>&nbsp;グラフ追加
          </button>
          <button class="btn btn-secondary text-white ml-1" type="button" (click)="hideGraph()">
            <i class="fa fa-minus-circle"></i>&nbsp;グラフ削除
          </button>
        </div>
      </div>
      </form>
      <hr>
    </div>
    <div class="card-body">
      @for (panel of panels; track panel_i; let panel_i = $index) {
        <div class="mb-4">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">対象年月</label>
                  <select class="form-control" [id]="'year_pay' + panel_i" [(ngModel)]="panel.yearMonth" [name]="'yearMonth' + panel_i" (ngModelChange)="loadPanel(panel_i)" [disabled]="downloading || loadingPanels > 0">
                    @for (opt of yearMonthOptions; track opt.id) {
                      <option [ngValue]="opt.id">{{ opt.name }}</option>
                    }
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">グラフ</label>
                  <select class="form-control" [id]="'select_graph' + panel_i" [(ngModel)]="panel.graphType" [name]="'graph' + panel_i" (ngModelChange)="loadPanel(panel_i)" [disabled]="downloading || loadingPanels > 0">
                    @for (opt of graphOptions; track opt.id) {
                      <option [ngValue]="opt.id">{{ opt.name }}</option>
                    }
                  </select>
                </div>
              </div>
            </div>
            @if (panel.graphType !== 4) {
              <div class="col-md-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label">グラフ本数</label>
                    <select class="form-control" [id]="'select_graph_number' + panel_i" [(ngModel)]="panel.graphNumber" [name]="'graphNumber' + panel_i" (ngModelChange)="loadPanel(panel_i)" [disabled]="downloading || loadingPanels > 0">
                      @for (opt of graphNumberOptions; track opt.id) {
                        <option [ngValue]="opt.id">{{ opt.name }}</option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            }
          </div>
          @if (!panel.showGraphArea) {
            <div class="mb-4">該当するデータはありません</div>
          } @else {
            <div [id]="'canvas-container_' + panel_i" class="mb-4 canvas-container" style="height: 300px;">
              <canvas [id]="'myChart' + panel_i"></canvas>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

@if (showDownloadModal) {
  <div class="modal-backdrop fade show" (click)="showDownloadModal = false"></div>
  <div class="modal fade show d-block" id="downloadModal" tabindex="-1" role="dialog" aria-labelledby="downloadModalLabel">
    <div class="modal-dialog" role="document"><div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="downloadModalLabel">ダウンロード</h5>
        <button type="button" class="close" aria-label="Close" (click)="showDownloadModal = false"><span class="text-white" aria-hidden="true">&times;</span></button>
      </div>
      <form name="marketingAllForm" method="POST" action="/" style="display: none;">
        <input type="text" name="marketingAll"><input type="text" name="selectYear">
      </form>
      <form novalidate name="downloadModalForm">
        <div class="modal-body"><div class="form-group row"><div class="col-md-12">
          <label class="col-form-label" for="export">対象年月</label>
          <select class="form-control" id="export" [(ngModel)]="exportMonth" name="exportMonth" (ngModelChange)="updateExportData()">
            @for (opt of yearMonthOptions; track opt.id) { <option [ngValue]="opt.id">{{ opt.name }}</option> }
          </select>
        </div></div></div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showDownloadModal = false"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
          <button class="btn btn-success text-white" type="button" (click)="download()" [disabled]="!isSetExport"><i class="fa s-icon-dawnload"></i>&nbsp;ダウンロード</button>
        </div>
      </form>
    </div></div>
  </div>
}
  `
})
export class MarketingAllComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private marketingService = inject(MarketingService);
  private authState = inject(AuthStateService);

  get userPermission(): number { return this.authState.currentUser?.role ?? 99; }

  panels: GraphPanel[] = [];
  loadingPanels = 0;
  downloading = false;
  showDownloadModal = false;
  exportMonth = '';
  isSetExport = false;
  private exportXlsx: any[] | null = null;
  private exportRequestId = 0;
  readonly yearMonthOptions = buildYearMonthOptions();
  readonly graphOptions = GRAPH_OPTIONS;
  readonly graphNumberOptions = GRAPH_NUMBER_OPTIONS;

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('マーケティング', 'fa fa-area-chart');
    const defaultYearMonth = this.yearMonthOptions[0]?.id ?? '';
    this.exportMonth = defaultYearMonth;
    this.panels = [{
      yearMonth: defaultYearMonth,
      graphType: 0,
      graphNumber: 10,
      showGraphArea: false,
      chartInstance: null,
    }];
    await this.loadPanel(0);
  }

  openDownloadModal(): void {
    this.exportMonth = this.exportMonth || this.panels[0]?.yearMonth || '';
    this.showDownloadModal = true;
    this.updateExportData();
  }

  // 旧版 marketing.js:61-71: 対象年月の全店データを先に取得し、取得完了までダウンロードを無効にする
  async updateExportData(): Promise<void> {
    this.isSetExport = false;
    this.exportXlsx = null;
    if (!this.exportMonth) return;
    const requestId = ++this.exportRequestId;
    const [year, month] = this.exportMonth.split('-').map(Number);
    try {
      const data = await this.marketingService.getAll(year, month);
      if (requestId !== this.exportRequestId) return;
      this.exportXlsx = [data];
      this.isSetExport = true;
    } catch {
      // 失敗時は ApiService が /error へ遷移する
    }
  }

  showGraph(): void {
    if (this.loadingPanels > 0 || this.panels.length >= GRAPH_OPTIONS.length) return;
    const defaultYearMonth = this.yearMonthOptions[0]?.id ?? '';
    this.panels.push({
      yearMonth: defaultYearMonth,
      graphType: 0,
      graphNumber: 10,
      showGraphArea: false,
      chartInstance: null,
    });
    const idx = this.panels.length - 1;
    this.loadPanel(idx);
  }

  hideGraph(): void {
    if (this.panels.length <= 1) return;
    const last = this.panels.pop();
    if (last?.chartInstance) last.chartInstance.destroy();
  }

  async loadPanel(idx: number): Promise<void> {
    const panel = this.panels[idx];
    if (!panel || !panel.yearMonth) return;
    const requestId = panel.requestId = (panel.requestId ?? 0) + 1;
    const isCurrent = () => this.panels[idx] === panel && panel.requestId === requestId;
    this.loadingPanels++;
    const [year, month] = panel.yearMonth.split('-').map(Number);
    try {
      const data: any = await this.marketingService.getAllByType(year, month, String(panel.graphType), panel.graphNumber);
      if (!isCurrent()) return;
      if (!data?.data?.length) {
        panel.showGraphArea = false;
        if (panel.chartInstance) { panel.chartInstance.destroy(); panel.chartInstance = null; }
        return;
      }
      panel.showGraphArea = true;
      setTimeout(() => { if (isCurrent()) this.renderChart(idx, data); }, 0);
    } catch {
      if (isCurrent()) panel.showGraphArea = false;
    } finally {
      this.loadingPanels--;
    }
  }

  private renderChart(idx: number, data: any): void {
    const panel = this.panels[idx];
    if (!panel) return;
    if (panel.chartInstance) { panel.chartInstance.destroy(); panel.chartInstance = null; }
    const ctx = (document.getElementById(`myChart${idx}`) as HTMLCanvasElement)?.getContext('2d');
    if (!ctx) return;
    ctx.canvas.height = 300;
    ctx.canvas.width = (document.getElementById(`canvas-container_${idx}`) as HTMLElement)?.clientWidth ?? 800;
    const color = '#4ebcc4';
    panel.chartInstance = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: data.label,
        datasets: [{
          label: data.labelName ?? '',
          data: data.data,
          borderColor: color,
          backgroundColor: color,
          lineTension: 0,
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: { yAxes: [{ type: 'linear', ticks: { suggestedMin: 0, suggestedMax: 0 } }] },
      },
    } as any);
  }

  // 旧版 marketing.js:110-123: 取得済みデータをhidden formでsubmitし、modalは即閉じる（data-dismiss）
  download(): void {
    if (!this.isSetExport || !this.exportXlsx) return;
    this.downloading = true;
    const opt = this.yearMonthOptions.find(o => o.id === this.exportMonth);
    const form = document.forms.namedItem('marketingAllForm') as HTMLFormElement | null;
    if (form) {
      form.method = 'POST';
      form.action = `${environment.apiBaseUrl}/marketing/excel/marketing_all`;
      (form.elements.namedItem('marketingAll') as HTMLInputElement).value = JSON.stringify(this.exportXlsx);
      (form.elements.namedItem('selectYear') as HTMLInputElement).value = opt?.name ?? this.exportMonth;
      form.submit();
    }
    this.showDownloadModal = false;
    setTimeout(() => { this.downloading = false; }, 5000);
  }
}
